__turbopack_context__.v({
  "aggregate": "blockFreenium-module-scss-module__8rpcjq__aggregate",
  "aggregateText": "blockFreenium-module-scss-module__8rpcjq__aggregateText",
  "cardFooter": "blockFreenium-module-scss-module__8rpcjq__cardFooter",
  "inlineLogo": "blockFreenium-module-scss-module__8rpcjq__inlineLogo",
  "modalBody": "blockFreenium-module-scss-module__8rpcjq__modalBody",
  "modalInner": "blockFreenium-module-scss-module__8rpcjq__modalInner",
  "modalText": "blockFreenium-module-scss-module__8rpcjq__modalText",
  "modalTitle": "blockFreenium-module-scss-module__8rpcjq__modalTitle",
  "quote": "blockFreenium-module-scss-module__8rpcjq__quote",
  "reviewerName": "blockFreenium-module-scss-module__8rpcjq__reviewerName",
  "spCard": "blockFreenium-module-scss-module__8rpcjq__spCard",
  "spHeader": "blockFreenium-module-scss-module__8rpcjq__spHeader",
  "spHeaderText": "blockFreenium-module-scss-module__8rpcjq__spHeaderText",
  "spRow": "blockFreenium-module-scss-module__8rpcjq__spRow",
  "stars": "blockFreenium-module-scss-module__8rpcjq__stars",
  "testimonials": "blockFreenium-module-scss-module__8rpcjq__testimonials",
  "trustpilotImg": "blockFreenium-module-scss-module__8rpcjq__trustpilotImg",
  "upgradeButton": "blockFreenium-module-scss-module__8rpcjq__upgradeButton",
});
